module.exports = __webpack_public_path__ + "img/cloud_bg.5c8be280.svg";